import { ContentBlockSlug, CustomContent } from '../types';
import { useContentBlockFieldParser } from './useContentBlockFieldParser';
import { parseItemFlipState } from '../utils';

export const useContentBlockItemFlip = (customContent: CustomContent[], slug: ContentBlockSlug) =>
  useContentBlockFieldParser(customContent, 'custom-item-flip', {
    slug,
    parser: parseItemFlipState
  });
